// extracted by mini-css-extract-plugin
export default {"loaderV2":"Loader_loaderV2__7CwxZ","backdrop":"Loader_backdrop__rVMoE","backdropDark":"Loader_backdropDark__BkO+8","progressContainer":"Loader_progressContainer__6Gnlv"};